import { render } from "./WalletFundsBreakdown.vue?vue&type=template&id=45dfdaaa&scoped=true"
import script from "./WalletFundsBreakdown.vue?vue&type=script&lang=js"
export * from "./WalletFundsBreakdown.vue?vue&type=script&lang=js"

import "./WalletFundsBreakdown.vue?vue&type=style&index=0&id=45dfdaaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dfdaaa"]])

export default __exports__